import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashQuestionDesktopLayout({children}) {
    // Used in MetaFlashScreen to frame screen content in
    // desktop mode

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"hidden grow w-[768px] lg:flex lg:flex-col justify-start items-center space-y-[24px] pb-[24px]"}>
            {children}
        </div>
    );
}